module.exports = __webpack_public_path__ + "static/media/METODOLOGIA_DE_CLASSIFICAÇÃO_DE_DOWNTIMES.1bd588b9.pdf";